import React, {useEffect, useState, MouseEvent } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { RouterConfig } from '../../core/utils/constants';
import Groups from '../groups/Groups';
import styles from './Users.module.scss';
import { SecondaryNav } from '@digicert/dcone-common-ui';
import { translate } from 'shared/helpers/utils';
import { IAppState } from 'core/store/store';
import { connect } from 'react-redux';
import { IAccessScope } from 'reducers/Reducers.interfaces';
import { fetchFeatureFlag } from 'secure-pages/tenants/tenant/signin-methods/SignInMethods.actions';
import { FeatureFlags } from 'core/constants';

export const UserAccessLayout = ({ profile, fetchFeatureFlag }) => {
  const history = useHistory();
  const [showGroups, setShowGroups] = useState(false);
  const [navItems, setNavItems] = useState<any>([
    {
      id: 'users',
      label: translate('navigation.access') as string,
      collapsed: false,
      subItems: [
        {
          id: 'all-users',
          label: translate('Users') as string,
          url: RouterConfig.urlMap.administrators,
          active: window.location.pathname === RouterConfig.urlMap.administrators,
          externalLink: false,
          disabled: false,
          onClick: (e: MouseEvent) => handleNavClick(RouterConfig.urlMap.administrators, e)
        }
      ]
    }
  ])

  useEffect(() => {
    if (!profile) return;
    fetchFeatureFlag(FeatureFlags.ENABLE_SCIM_CONFIGURATION, profile?.primary_account_id).then(response => {
      if (response && profile.access_scope === IAccessScope.account) {
        setShowGroups(true);
        setNavItems(prevNavItems => {
          const [usersNav] = prevNavItems;
          const hasGroups = usersNav.subItems.some(sub => sub.id === 'groups');
          if (hasGroups) return prevNavItems;
          return [
            {
              ...usersNav,
              subItems: [
                ...usersNav.subItems,
                {
                  id: 'groups',
                  label: translate('navigation.groups') as string,
                  url: RouterConfig.urlMap.groups,
                  active: window.location.pathname === RouterConfig.urlMap.groups,
                  externalLink: false,
                  disabled: false,
                  onClick: (e: MouseEvent) => handleNavClick(RouterConfig.urlMap.groups, e)
                }
              ]
            }
          ];
        });
      }
    });
  }, [profile]);

  const handleNavClick = (url: string, e: MouseEvent) => {
    e.preventDefault();
    if (window.location.pathname !== url) {
      history.push(url);
    }
  };

  return (
    <section className={styles.users}>
      <SecondaryNav
        key={showGroups ? 'users-groups' : 'users'}
        className={styles.secondaryNav}
        items={navItems}
      />
      <div className={styles.content}>
        <Switch>
          <Route exact path={RouterConfig.urlMap.groups} component={Groups} />
        </Switch>
      </div>
      <div></div>
    </section>
  );
};

export default connect((state: IAppState) => {
  return {
    profile: state.profile.data,
  }
},
  {
    fetchFeatureFlag
  })(UserAccessLayout);
